import { Directive, inject, type OnInit } from '@angular/core';
import { RouterLinkActive } from '@angular/router';
import { ListGroupExpandableComponent } from './list-group-expandable.component';

@Directive({
  selector: '[list-group-expand-parent]',
  standalone: false,
})
export class ListGroupExpandParentDirective implements OnInit {
  private parentComponent = inject(ListGroupExpandableComponent);
  private routerLinkActive = inject(RouterLinkActive);

  ngOnInit() {
    setTimeout(() => {
      if (this.routerLinkActive.isActive) {
        this.parentComponent.expandByChild();
      }
    }, 500);
  }
}
